import type { BrandingDetailsType } from '@root/@types/types';

export const normaliseBranding = <T = BrandingDetailsType>(branding: T & { sk: string; pk: string }): T => ({
  ...branding,
  id: branding.sk,
});
